export default [
  {
    path: "/pcp/industrializacao",
    name: "pcp.industrializacao",
    label: "Industrialização",
    component: () => import("@/components/industrializacao/MenuIndustrializacao.vue"),
  },
  {
    path: "/pcp/industrializacao/industrializadores",
    name: "pcp.industrializacao.industrializadores",
    label: "Industrializadores",
    component: () =>
      import("@/components/industrializacao/cadastros/industrializador/gerenciar-industrializadores.vue"),
  },
  {
    path: "/pcp/industrializacao/saldos",
    name: "pcp.industrializacao.saldos",
    label: "Saldos em Terceiros",
    component: () => import("@/components/industrializacao/movimentacoes/gerenciar-saldos.vue"),
  },
  {
    path: "/pcp/industrializacao/lancar-nota-manual",
    name: "pcp.industrializacao.lancar-nota-manual",
    label: "Lançamento Manual",
    meta: { permission: "pcp.industrializacao.movimentacoes.ajuste" },
    component: () => import("@/components/industrializacao/importacao/lancar-nota-manual.vue"),
  },
  {
    path: "/pcp/industrializacao/importar-xml",
    name: "pcp.industrializacao.importar-xml",
    label: "Importar XML",
    component: () => import("@/components/industrializacao/importacao/importar-xml.vue"),
  },
  {
    path: "/pcp/industrializacao/notas-importadas",
    name: "pcp.industrializacao.notas-importadas",
    label: "Notas Importadas",
    component: () => import("@/components/industrializacao/importacao/gerenciar-notas-importadas.vue"),
  },
  {
    path: "/pcp/industrializacao/notas-importadas/:id",
    name: "pcp.industrializacao.notas-importadas.show",
    label: "Nota Importada",
    component: () => import("@/components/industrializacao/importacao/nota-importada.vue"),
  },
  {
    path: "/pcp/industrializacao/relatorios/rendimento-industrializador",
    name: "pcp.industrializacao.relatorios.rendimento-industrializador",
    label: "Rendimento por Industrializador",
    component: () => import("@/components/industrializacao/relatorios/rendimento-industrializador.vue"),
  },
  {
    path: "/pcp/industrializacao/ordens",
    name: "pcp.industrializacao.ordens",
    label: "Ordens de Industrialização",
    // Hub: a listagem/menu usa o nome da rota (o que o perfil marca ao liberar o grupo).
    // Também aceita as ações já existentes na árvore — `.visualizar` nunca foi gerada no RBAC.
    meta: {
      permission: [
        "pcp.industrializacao.ordens",
        "pcp.industrializacao.ordens.criar",
        "pcp.industrializacao.ordens.editar",
        "pcp.industrializacao.ordens.excluir",
        "pcp.industrializacao.ordens.gerar-pdf",
        "pcp.industrializacao.ordens.enviar-email",
        "pcp.industrializacao.ordens.vincular",
        "pcp.industrializacao.ordens.configuracoes",
        "pcp.industrializacao.ordens.configurar-parametros",
      ],
    },
    component: () => import("@/components/industrializacao/ordens/gerenciar-ordens.vue"),
  },
  {
    path: "/pcp/industrializacao/ordens/nova",
    name: "pcp.industrializacao.ordens.criar",
    label: "Nova Ordem de Industrialização",
    meta: { permission: "pcp.industrializacao.ordens.criar" },
    component: () => import("@/components/industrializacao/ordens/ordem-form.vue"),
  },
  {
    path: "/pcp/industrializacao/ordens/:id/editar",
    name: "pcp.industrializacao.ordens.editar",
    label: "Editar Ordem de Industrialização",
    meta: { permission: "pcp.industrializacao.ordens.editar" },
    component: () => import("@/components/industrializacao/ordens/ordem-form.vue"),
  },
  {
    path: "/pcp/industrializacao/ordens/configuracoes",
    name: "pcp.industrializacao.ordens.configuracoes",
    label: "Configurações da Industrialização",
    meta: {
      permission: ["pcp.industrializacao.ordens.configuracoes", "pcp.industrializacao.ordens.configurar-parametros"],
    },
    component: () => import("@/components/industrializacao/ordens/gerenciar-configuracoes.vue"),
  },
];
